<template>
  <UnstyledCta class="MultilinkItem" :text="title" :action="cta?.action">
    <span class="title">{{ title }}</span>
    <span class="ctaLink">
      {{ cta?.text }}
      <span class="icon" v-html="arrowRightSvg"></span>
    </span>
  </UnstyledCta>
</template>

<script setup>
import arrowRightSvg from '~/assets/ui/link-arrow-right.svg?raw'

const { title, cta } = defineProps({
  title: String,
  cta: Object,
})
</script>

<style scoped>

.MultilinkItem {
  --link-font-size: var(--font-size-3);
  display: block;
  background-color: white;
  border-radius: 8px;
  padding: var(--spacing-4) var(--spacing-5);
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: background-color 0.15s;
}

.MultilinkItem:hover {
  background-color: #eee;
}

.title {
  font-weight: 600;
  font-size: var(--font-size-2);
  color: var(--text-color-black);
}

.ctaLink {
  flex-shrink: 0;
}

.ctaLink {
  display: inline-block;
  font-weight: 400;
  font-size: var(--link-font-size, var(--font-size-3));
  line-height: 1.3;
  color: var(--brand-color);
  transition: color 0.15s;
}

.ctaLink .icon {
  display: inline-block;
  margin-left: 0.33em;
  position: relative;
  left: 0;
  transition: left 0.15s;
}

.MultilinkItem:hover .ctaLink .icon {
  left: 3px;
}
</style>
